import { ChevronRight } from 'lucide-react';
import React from 'react';

const CellExpanderFormatter = ({ expanded, tabIndex, onCellExpand }) => {
  return (
    <div
      onClick={onCellExpand}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onCellExpand();
        }
      }}
      tabIndex={tabIndex}
      className="flex justify-center items-center h-full text-gray-400 transition-colors cursor-pointer"
      role="button"
      aria-expanded={expanded}
    >
      <ChevronRight size={15} className={`transition-transform ${expanded ? 'rotate-90' : 'rotate-0'}`} />
      {/* <svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={`lucide lucide-chevron-down w-4 h-4 transition-transform ${expanded ? 'rotate-180' : 'rotate-190'}`}
      >
			<path d="m6 9 6 6 6-6"></path>
      </svg> */}
    </div>
  );
};

export default CellExpanderFormatter;
export { CellExpanderFormatter };

